import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-region-modal',
  templateUrl: './region-modal.component.html',
  styleUrls: ['./region-modal.component.scss']
})
export class RegionModalComponent implements OnInit {

  regionCode: number = 0;
  widget: any;
  fileType: number = 0;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<RegionModalComponent>,
    private dialog: MatDialog) { }

  ngOnInit(): void {
    this.widget = this.data;
  }

  selectRegion(evt) {
    this.regionCode = +evt.target.value;
  }

  selectFileType(evt) {
    this.fileType = +evt.target.value;
  }

  close(): void {
    let _obj = {
      regionCode: this.regionCode == 0 ? null : this.regionCode,
      widget: this.widget.id,
      fileType: this.fileType == 0 ? null : this.fileType
    }
    this.dialogRef.close(_obj);
  }

  closeModalReport() {
    let _obj = {
      regionCode: null,
      widget: '',
      fileType: null
    }
    this.dialogRef.close(_obj);
  }

}
